import {
  Box,
  Masonry,
  RouterTabContent,
  RouterTabs,
  useRouter,
  useSidebar,
  useTheme,
} from '@forgeglobal/design-framework'
import { IssuerHeader } from 'components/issuers/IssuerHeader'
import { IssuerLastRound } from 'components/issuers/IssuerLastRound'
import { IssuerLinks } from 'components/issuers/IssuerLinks'
import { IssuerMarketplaceCoverage, IssuerPartnershipsCoverage } from 'components/issuers/IssuerCoverage'
import { IssuerOpportunities } from 'components/issuers/IssuerOpportunities'
import { IssuerSidebar } from 'components/issuers/IssuerSidebar'
import { IssuerSupplyDemandGraph } from 'components/issuers/IssuerSupplyDemandGraph'
import { IssuerTradeSummary } from 'components/issuers/IssuerTradeSummary'
import { LatestTrade } from 'components/issuers/LatestTrade'
import { PlatformSettings } from 'components/issuers/PlatformSettings'
import { Relationships } from 'components/accounts/AccountConnections'
import Documents from 'components/shared/Documents'
import React, { Fragment } from 'react'

export const Issuer: React.FC = () => {
  const theme = useTheme()
  const { match } = useRouter<{ id: string }>()
  const [expanded, setExpanded] = React.useState<string>('conversations')
  const id = match.params.id

  const { showSidebar } = useSidebar(
    <IssuerSidebar issuerAccountId={id} expanded={expanded} setExpanded={setExpanded} />,
    [expanded, setExpanded, id]
  )

  const openSidebarSection = (name: string) => {
    showSidebar()
    setExpanded(name)
  }

  const sections = [
    <IssuerSupplyDemandGraph key="graph" />,
    <IssuerLastRound key="last_round" />,
    <Relationships key="relationships" />,
    <IssuerTradeSummary key="trade_summary" />,
    <LatestTrade key="latesttrade" openSidebar={() => openSidebarSection('trade-history')} />,
    <IssuerLinks key="links" />,
    <IssuerMarketplaceCoverage key="marketplace" />,
    <IssuerPartnershipsCoverage key="partnerships" />,
    <PlatformSettings key="platform_data" />,
    <Documents key="documents" accountId={id} />,
  ].filter(e => !!e)

  return (
    <Fragment>
      <IssuerHeader />
      <Box style={{ padding: theme.content.padding, paddingTop: 0, overflowAnchor: 'none', minHeight: '90vh' }}>
        <RouterTabs>
          <RouterTabContent label="issuer details">
            <Masonry items={sections} />
          </RouterTabContent>
          <RouterTabContent label="opportunities">
            <IssuerOpportunities issuerId={id} />
          </RouterTabContent>
        </RouterTabs>
      </Box>
    </Fragment>
  )
}
